if ('serviceWorker' in navigator) {
  window.addEventListener('load', function () {
    // eslint-disable-next-line
    navigator.serviceWorker.register(baseUri + 'sw.js').then(function (registration) {
      registration.update()
    })
  })
}



// WEBPACK FOOTER //
// ./src/pwa.js